import { Component, computed, inject, input, TemplateRef, contentChild } from '@angular/core';
import { ExpandableComponent } from '../../../shared/expandable-component/expandable.component';
import { CommonModule } from '@angular/common';
import { IconNameType } from '../../../shared/icons/icon-name-type.enum';
import { IconComponent } from '../../../shared/icons/icon.component';
import { AuditService } from '../../services/audit.service';
import { TranslocoPipe } from '@ngneat/transloco';

@Component({
  selector: 'cwo-ingredient-group',
  standalone: true,
  imports: [ExpandableComponent, CommonModule, IconComponent, TranslocoPipe],
  templateUrl: './ingredient-group.component.html',
  styleUrl: './ingredient-group.component.scss',
})
export class IngredientGroupComponent {
  groupName = input.required<string>();
  required = input(false);
  scrollMarginTop = 0;
  auditService = inject(AuditService)
  expanded = true;
  iconNameType = IconNameType;

  groupExpandableId = computed(
    () => `${this.groupName()}-expandable-section`
  );

  readonly ingredientsList = contentChild<TemplateRef<any>>('ingredientsList');

  calcualteScrollMarginTop() {
    const informationContainerElRef = document.getElementById(
      'item-editor-item-information-container'
    );
    this.scrollMarginTop = informationContainerElRef?.getBoundingClientRect()
      .height
      ? informationContainerElRef?.getBoundingClientRect().height + 10
      : 0;
  }

  handleExpansion(expanded: boolean) {
    this.calcualteScrollMarginTop();
    this.expanded = expanded;
     this.auditService.createAudit(() => `group ${this.groupName()} ${this.expanded ? 'expanded' : 'collapsed'}.`);
    if (this.expanded) {
      const modalContent = document.getElementById(
        'item-editor-scrollable-wrapper'
      );
      const el = document.getElementById(this.groupExpandableId());
      const elContent = document.getElementById(
        this.groupExpandableId() + 'content'
      );
      const footer = document.getElementById('item-editor-footer');

      if (el && elContent && modalContent && footer) {
        const modalContentRect = modalContent.getBoundingClientRect();
        const elContentRect = elContent.getBoundingClientRect();
        const footerRect = footer.getBoundingClientRect();

        // Calculate the visible area within the modal content
        const visibleAreaHeight = modalContentRect.height - footerRect.height;

        // Check if the content's bottom position exceeds the visible area
        if (elContentRect.bottom > visibleAreaHeight) {
          // Wait for the category to be fully expanded before scrolling
          setTimeout(() => {
            el.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }, 10);
        }
      }
    }
  }
}
